import { useQuery } from '@tanstack/react-query';
import { axiosRequest } from '@lib/axios';

/**
 * @typedef {import("@tanstack/react-query").UseQueryResult<PearsResult, Error>} PearsQueryResult
 */
/**
 * @typedef {Object} PearsResult
 * @property {string[]} languageLabels
 * @property {string[]} partners
 */
/**
 * React Query wrapper for the Pears query.
 *
 * @returns {PearsQueryResult}
 */
const usePearsQuery = () => {
  /**
   * Custom hook wrapping useQuery
   * @returns {PearsQueryResult} The query result object containing data, isLoading, error, etc.
   */
  return useQuery({
    queryKey: ['pears'],
    queryFn: async () => axiosRequest({ method: 'GET', url: '/data/pears' }),
    structuralSharing: false,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default usePearsQuery;
